import { NextSeo } from 'next-seo';
import React from 'react';

import Footer from 'components/Footer';
import pages from 'config/pages';
import { getClient } from 'content/sanity.server';
import { recentArticlesQuery } from 'content/queries';
import Article from 'models/articles/Article';
import ArticleCard from 'components/cards/ArticleCard';

export async function getStaticProps({ preview = false }) {
    const articles = await getClient(preview).fetch(recentArticlesQuery);

    return {
        props: {
            preview,
            articles
        },
        revalidate: 60
    };
}

function NamigiPage({ articles }: { articles: Article[] }) {
    return (
        <div className="single-page pt-8" id="namigi">
            <NextSeo title={pages.namigi.title} />
            <div className="container">
                <h1>ZBIRKE IZLETNIH IDEJ ZA VSAKOGAR</h1>
                <p className="max-w-xl mt-2 ">
                    Ne veš kam peljati partnerja na romantičen izlet? Iščeš manj znane destinacije za družino ali svojo
                    družbo? Te zanimajo lokacije, kjer ne bo pretirane gneče? Ali si le želiš doživeti nekaj novega?
                    Razišči med idejami za izlet, ki smo jih zate zbrali v pregledne zbirke.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-8  mt-10">
                    {articles.map((article) => (
                        <ArticleCard article={article} key={article._id} />
                    ))}
                </div>
            </div>
            <div className="mt-24">
                <Footer />
            </div>
        </div>
    );
}

export default NamigiPage;
